import { useRef, useState } from "react";
import { usePaystackPayment } from "react-paystack";
import { payEvent } from "../components/Pay/PayOverlay";

const usePayStack = () => {
  const [config, setConfig] = useState({});
  const initializePayment = usePaystackPayment(config);
  const last = useRef(null); // the latest details, available immediately (no waiting for React)

  const setPayStackConfig = ({ amount, reference, email }) => {
    const next = {
      publicKey: process.env.REACT_APP_PAYSTACK_PK || "pk_live_d0b21acfa964eb479672bc376953fc68a85283b6", // staging sets a test key
      amount: amount * 100,
      reference,
      email,
      currency: "NGN", // USD needs Paystack approval first
      channels: ["card", "bank_transfer", "ussd"], // shown in this order (only those enabled on the Paystack account appear)
    };
    last.current = next;
    setConfig(next);
  };

  // Old two-step way (still used by the "Proceed to Payment" fallback box).
  const PayWithPayStack = (onSuccess, onClose) => {
    initializePayment(onSuccess, onClose);
  };

  // Open Paystack straight away with the latest details. Returns false if Paystack's script isn't ready,
  // so the caller can fall back to the old "Proceed to Payment" box.
  // opts.quiet: skip the paper checkout screens (PayOverlay); the caller shows its own (wallet top-up).
  const openPaystackNow = (onSuccess, onClose, opts = {}) => {
    const c = last.current;
    const Pop = typeof window !== "undefined" ? window.PaystackPop : null;
    if (!c) { console.warn("[TNS pay] fallback: no payment details were given before opening"); return false; }
    if (!Pop || typeof Pop.setup !== "function") { console.warn("[TNS pay] fallback: Paystack script not loaded yet"); return false; }
    try {
      // Same arguments react-paystack itself passes to Paystack.
      const handler = Pop.setup({
        key: c.publicKey,
        email: c.email,
        amount: c.amount,
        ref: c.reference,
        currency: c.currency,
        channels: c.channels,
        callback: (response) => (opts.quiet ? onSuccess && onSuccess(response) : payEvent("paid", { reference: (response && response.reference) || c.reference, amount: c.amount / 100, onDone: () => onSuccess && onSuccess(response) })),
        onClose: () => { if (onClose) onClose(); if (!opts.quiet) payEvent("closed", { amount: c.amount / 100 }); },
      });
      if (!handler || typeof handler.openIframe !== "function") { console.warn("[TNS pay] fallback: Paystack gave no payment window", handler); return false; }
      if (!opts.quiet) payEvent("open", { amount: c.amount / 100 });
      handler.openIframe();
      console.info("[TNS pay] opened Paystack directly", { ref: c.reference, amount: c.amount });
      return true;
    } catch (e) {
      console.warn("[TNS pay] fallback: Paystack refused the details -", e && e.message);
      return false;
    }
  };

  return {
    setPayStackConfig,
    PayWithPayStack,
    openPaystackNow,
  };
};

export default usePayStack;
